var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tc-hero',{staticClass:"sk-hero",class:{ dark: _vm.$store.getters.darkmode },attrs:{"hasFixedHeader":false}},[_c('img',{attrs:{"src":_vm.src,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }